import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeleteIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.8125 5.16667H13.4792M3.47917 5.16667L4.14583 13.1667C4.14583 13.5203 4.28631 13.8594 4.53636 14.1095C4.78641 14.3595 5.12554 14.5 5.47917 14.5H10.8125C11.1661 14.5 11.5053 14.3595 11.7553 14.1095C12.0054 13.8594 12.1458 13.5203 12.1458 13.1667L12.8125 5.16667M6.14583 5.16667V3.16667C6.14583 2.98986 6.21607 2.82029 6.3411 2.69526C6.46612 2.57024 6.63569 2.5 6.8125 2.5H9.47917C9.65598 2.5 9.82555 2.57024 9.95057 2.69526C10.0756 2.82029 10.1458 2.98986 10.1458 3.16667V5.16667",
		stroke: "#A7B3BE",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.8125 7.83334V11.8333M9.47917 7.83334V11.8333",
		stroke: "#A7B3BE",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgDeleteIcon;
